
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Content load handler
// - Fügt Klassen bei DOMContentLoaded / load hinzu
// - Lazy-load für Elemente mit `data-src`
// - Entfernt optionalen Preloader (#preloader)
// Lazy Loading Handler
// - Lazy-load für Elemente mit `data-src`
// - Verwendet IntersectionObserver für Performance
// - Video-Setup für proxy loading via HTML
// Speichern der gehashten Video-Pfade
let $32a3a3f71f269bc5$var$videoSources = {
    desktop: {},
    mobile: {}
};
function $32a3a3f71f269bc5$var$isImage(el) {
    return el.tagName.toLowerCase() === 'img';
}
function $32a3a3f71f269bc5$var$loadResource(el) {
    return new Promise((resolve)=>{
        if ($32a3a3f71f269bc5$var$isImage(el)) {
            const img = el;
            const src = img.dataset.src;
            if (!src) return resolve();
            img.onload = ()=>img.classList.add('loaded');
            img.onerror = ()=>img.classList.add('error');
            img.src = src;
            delete img.dataset.src;
            return resolve();
        }
        const src = el.getAttribute('data-src');
        if (src) {
            if (el instanceof HTMLIFrameElement) el.src = src;
            else el.setAttribute('style', (el.getAttribute('style') || '') + `background-image:url('${src}')`);
            el.removeAttribute('data-src');
        }
        resolve();
    });
}
function $32a3a3f71f269bc5$export$c3bf910d26c7ca3b() {
    const v = document.getElementById('logoVideo');
    if (!v) return;
    Array.from(v.querySelectorAll('source')).forEach((source)=>{
        const src = source.getAttribute('src');
        const type = source.getAttribute('type') || '';
        if (!src) return;
        const isMobile = source.getAttribute('data-mobile') === 'true';
        if (isMobile) $32a3a3f71f269bc5$var$videoSources.mobile[type] = src;
        else $32a3a3f71f269bc5$var$videoSources.desktop[type] = src;
        // src entfernen, damit Video nicht sofort geladen wird
        source.removeAttribute('src');
    });
}
function $32a3a3f71f269bc5$export$730a095e8e4092e5() {
    const v = document.getElementById('logoVideo');
    if (!v) return;
    const isMobile = window.matchMedia('(max-width:768px)').matches;
    const variant = isMobile ? $32a3a3f71f269bc5$var$videoSources.mobile : $32a3a3f71f269bc5$var$videoSources.desktop;
    Array.from(v.querySelectorAll('source')).forEach((source)=>{
        const type = source.getAttribute('type') || '';
        if (variant[type]) source.setAttribute('src', variant[type]);
    });
    v.load();
    v.autoplay = true;
    v.play().catch(()=>{});
}
function $32a3a3f71f269bc5$export$3b98fa096e9fc203(root = document) {
    return new Promise((resolve)=>{
        const nodes = Array.from(root.querySelectorAll('[data-src]'));
        if (!nodes.length) {
            resolve();
            return;
        }
        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries, obs)=>{
                entries.forEach((entry)=>{
                    if (!entry.isIntersecting) return;
                    const el = entry.target;
                    $32a3a3f71f269bc5$var$loadResource(el).catch(()=>{});
                    obs.unobserve(entry.target);
                });
            }, {
                root: null,
                threshold: 0
            });
            nodes.forEach((n)=>io.observe(n));
            resolve(); // IntersectionObserver Setup fertig
        } else // Fallback: load all immediately
        Promise.all(nodes.map((n)=>$32a3a3f71f269bc5$var$loadResource(n))).then(()=>resolve()).catch(()=>resolve());
    });
}


// Mobile Menu Handler
// - Toggle-Funktionalität für das Hamburger-Menü
// - Backdrop-Handling zum Schließen
// - Smooth Scroll zu Ankern mit Topbar-Offset
function $e745b9ef5c505b0a$var$smoothScrollToTarget(href) {
    // Anchor href auslesen
    if (!href.startsWith('#')) return;
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    if (!target) return;
    // Topbar-Höhe ermitteln
    const topbar = document.querySelector('.fuelpipe-topbar');
    const topbarHeight = topbar ? topbar.offsetHeight : 0;
    // Scroll-Position berechnen
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - topbarHeight;
    // Smooth Scroll ausführen
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
}
function $e745b9ef5c505b0a$export$b61d4be8ddba9539() {
    const toggle = document.querySelector('.menu-toggle');
    const backdrop = document.querySelector('.menu-backdrop');
    const navLinks = document.querySelectorAll('.fuelpipe-topbar nav a');
    if (!toggle || !backdrop) return;
    const toggleMenu = ()=>{
        const isOpen = document.body.classList.toggle('nav-open');
        toggle.classList.toggle('active');
        toggle.setAttribute('aria-expanded', String(isOpen));
    };
    toggle.addEventListener('click', (e)=>{
        e.stopPropagation();
        toggleMenu();
    });
    backdrop.addEventListener('click', toggleMenu);
    navLinks.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            const href = link.getAttribute('href');
            // Wenn es ein Anker ist, smooth scroll triggern
            if (href?.startsWith('#')) {
                e.preventDefault();
                $e745b9ef5c505b0a$var$smoothScrollToTarget(href);
            }
            // Menü schließen wenn offen
            if (document.body.classList.contains('nav-open')) toggleMenu();
        });
    });
}


// Scroll Animations Handler
// - Element-basierte Animationen
// - Jedes Element mit [data-animate] triggert unabhängig
// - Respektive auch bei langen Sections früh auslösen
function $b611819413d23cbb$export$4ae6feb6159b4594() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    if (!animatedElements.length) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            const element = entry.target;
            const customDelay = parseFloat(element.getAttribute('data-delay') || '0') * 1000; // in ms
            element.style.animationDelay = `${customDelay}ms`;
            element.classList.add('animate-in');
            // Element nach Animation nicht mehr beobachten
            observer.unobserve(element);
        });
    }, {
        threshold: 0.1
    });
    // Alle animierten Elemente beobachten
    animatedElements.forEach((element)=>{
        observer.observe(element);
    });
}


// Scroll Morph Handler
// - Überblendung zwischen .normal und .morph Bildern gekoppelt an Scroll-Fortschritt
// - Beginn: Element in Bildschirmmitte
// - Ende: Element am oberen Rand (minus Topbar-Höhe)
// - Bidirektional: Vorwärts und Rückwärts-Scrollen funktioniert
const $042d2a1a583b6f8f$var$TOPBAR_HEIGHT = 80; // px - CSS @topbar-height
function $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c() {
    const morphContainers = document.querySelectorAll('.foto-morph');
    if (!morphContainers.length) return;
    const configs = Array.from(morphContainers).map((container)=>{
        const morphImg = container.querySelector('img.morph');
        return {
            container: container,
            morphImg: morphImg
        };
    }).filter((config)=>config.morphImg);
    if (!configs.length) return;
    // Update Morph-Opacity kontinuierlich beim Scroll
    const updateMorphOpacity = ()=>{
        configs.forEach(({ container: container, morphImg: morphImg })=>{
            // Bounding Rect vom Container
            const rect = container.getBoundingClientRect();
            const containerCenter = rect.top; // + rect.height / 2;
            const isMobile = window.matchMedia('(max-width:768px)').matches;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            const startPoint = isMobile ? viewportHeight * 0.45 - 100 : viewportHeight * 0.45; // Bildschirmmitte
            const endPoint = isMobile ? $042d2a1a583b6f8f$var$TOPBAR_HEIGHT : $042d2a1a583b6f8f$var$TOPBAR_HEIGHT + 100; // Oberer Rand minus Topbar
            // Scroll-Fortschritt berechnen (0 = Start, 1 = Ende)
            // Wenn Container-Mitte in Bildschirmmitte ist: progress = 0
            // Wenn Container-Mitte am oberen Rand ist: progress = 1
            const distanceFromMidpoint = startPoint - containerCenter;
            const activationRange = startPoint - endPoint;
            // Fortschritt clamped zwischen 0 und 1
            let progress = distanceFromMidpoint / activationRange;
            progress = Math.max(0, Math.min(1, progress));
            // Opacity setzen (nur für .morph Bild)
            morphImg.style.opacity = String(progress);
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateMorphOpacity();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


// Scroll Heading Handler
// - Zerlegt .heading h2 in einzelne Wörter
// - Animiert Wörter einzeln beim Scrollen (blur + skew + opacity)
// - Start: wenn h2 sichtbar wird (unten im Viewport)
// - Ende: wenn h2 oberhalb der Bildschirmmitte
function $0e5e9a9af84e2131$export$c80c5dc5e82459e5() {
    const headings = document.querySelectorAll('.heading h2[data-animate]');
    if (!headings.length) return;
    const configs = Array.from(headings).map((h2)=>{
        const heading = h2.closest('.heading');
        if (!heading) return null;
        const originalText = h2.textContent || '';
        const words = originalText.trim().split(/\s+/);
        // h2 leeren und mit Spans füllen
        h2.innerHTML = '';
        const wordSpans = words.map((word)=>{
            const span = document.createElement('span');
            span.textContent = word;
            span.style.display = 'inline-block';
            span.style.marginRight = '0.3em';
            span.style.willChange = 'filter, transform, opacity';
            h2.appendChild(span);
            return {
                span: span
            };
        });
        return {
            heading: heading,
            h2: h2,
            wordSpans: wordSpans
        };
    }).filter((config)=>config !== null);
    if (!configs.length) return;
    // Update Heading-Animation kontinuierlich beim Scroll
    const updateHeadingAnimation = ()=>{
        configs.forEach(({ heading: heading, wordSpans: wordSpans })=>{
            // Bounding Rect vom Heading
            const rect = heading.getBoundingClientRect();
            const headingCenter = rect.top + rect.height / 2;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            // Start: Element kommt unten in Sicht (viewportHeight)
            // Ende: Element ist oberhalb der Bildschirmmitte (viewportHeight / 2)
            const startPoint = viewportHeight; // Unten - Animation beginnt
            const endPoint = viewportHeight / 2; // Mitte - Animation abgeschlossen
            // Fortschritt je näher Element nach oben kommt
            const distanceFromMidpoint = startPoint - headingCenter;
            const activationRange = startPoint - endPoint;
            // Fortschritt clamped zwischen 0 und 1
            let overallProgress = distanceFromMidpoint / activationRange;
            overallProgress = Math.max(0, Math.min(1, overallProgress));
            // Berechne gesamte Stagger-Verzögerung (vom ersten bis letzten Wort)
            const totalWordDelay = (wordSpans.length - 1) * 0.08;
            // Skaliere overallProgress so, dass die Animation über ALLE Wörter läuft
            const adjustedProgress = overallProgress * (1 + totalWordDelay);
            // Für jedes Wort: individueller Fortschritt
            wordSpans.forEach((word, index)=>{
                // Jedes Wort animiert mit Stagger-Effekt
                const wordDelay = index * 0.08; // 8% Stagger pro Wort
                // Fortschritt für dieses Wort (0 bis 1, mit Stagger)
                const wordProgress = Math.max(0, Math.min(1, adjustedProgress - wordDelay));
                // Interpoliere Blur-Effekt
                const blur = 8 * (1 - wordProgress); // Von 8px zu 0px
                const skew = -20 * (1 - wordProgress); // Von -20deg zu 0deg
                const opacity = wordProgress; // Von 0 zu 1
                // CSS anwenden
                word.span.style.filter = `blur(${blur}px)`;
                word.span.style.transform = `skew(${skew}deg)`;
                word.span.style.opacity = String(opacity);
            });
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateHeadingAnimation();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


// Automatisch erzeugt durch scripts/generateTruckFrames.cjs
var $d824ac02dcbe793c$exports = {};
$d824ac02dcbe793c$exports = import.meta.resolve("4XzoL");


var $9fcc4e1a87df6bb1$exports = {};
$9fcc4e1a87df6bb1$exports = import.meta.resolve("jlOne");


var $105107585656d7a1$exports = {};
$105107585656d7a1$exports = import.meta.resolve("1Tb7s");


var $cd6b3d843dd36c7a$exports = {};
$cd6b3d843dd36c7a$exports = import.meta.resolve("j5p3S");


var $f98255bb20d6f01d$exports = {};
$f98255bb20d6f01d$exports = import.meta.resolve("fwXYo");


var $b817889c311d658c$exports = {};
$b817889c311d658c$exports = import.meta.resolve("bWO4c");


var $2f2837cb7c29ed33$exports = {};
$2f2837cb7c29ed33$exports = import.meta.resolve("6pgvj");


var $8ea81eb3acc6e8ae$exports = {};
$8ea81eb3acc6e8ae$exports = import.meta.resolve("3TPGp");


var $9eb516caffc94144$exports = {};
$9eb516caffc94144$exports = import.meta.resolve("7uNru");


var $e04717558299131f$exports = {};
$e04717558299131f$exports = import.meta.resolve("jWCaI");


var $824ee16e93d6d83c$exports = {};
$824ee16e93d6d83c$exports = import.meta.resolve("2Zaz7");


var $55c81d50a45037f7$exports = {};
$55c81d50a45037f7$exports = import.meta.resolve("eJjLn");


var $deea6468d731ed7e$exports = {};
$deea6468d731ed7e$exports = import.meta.resolve("18aQm");


var $a0054ada609884ab$exports = {};
$a0054ada609884ab$exports = import.meta.resolve("2ZOAQ");


var $98954c3574c32d7a$exports = {};
$98954c3574c32d7a$exports = import.meta.resolve("eaVVp");


var $0a928d506f97f81f$exports = {};
$0a928d506f97f81f$exports = import.meta.resolve("9O01n");


var $220823fd231c632e$exports = {};
$220823fd231c632e$exports = import.meta.resolve("2jxc5");


var $c9a3e84b870b2c5a$exports = {};
$c9a3e84b870b2c5a$exports = import.meta.resolve("fIUWi");


var $6ff243045f5e7fff$exports = {};
$6ff243045f5e7fff$exports = import.meta.resolve("cwmNl");


var $55526fcb014aa526$exports = {};
$55526fcb014aa526$exports = import.meta.resolve("jszUc");


var $86bda99d23b7338e$exports = {};
$86bda99d23b7338e$exports = import.meta.resolve("4uGNZ");


var $60827b91d77b2f98$exports = {};
$60827b91d77b2f98$exports = import.meta.resolve("gWd5u");


var $2b618d3566cde27e$exports = {};
$2b618d3566cde27e$exports = import.meta.resolve("dWS65");


var $ed4fc4c9122b467c$exports = {};
$ed4fc4c9122b467c$exports = import.meta.resolve("cGqpm");


var $2410511d0f6ef72c$exports = {};
$2410511d0f6ef72c$exports = import.meta.resolve("1fmT0");


var $b972700e0bee8397$exports = {};
$b972700e0bee8397$exports = import.meta.resolve("lRYPY");


var $876ed3e87ba4fa41$exports = {};
$876ed3e87ba4fa41$exports = import.meta.resolve("8vEQk");


var $b4adf4affb7af5fb$exports = {};
$b4adf4affb7af5fb$exports = import.meta.resolve("bJBcL");


var $25bdebded56abd07$exports = {};
$25bdebded56abd07$exports = import.meta.resolve("bu4cV");


var $a3c7a446c9cb575f$exports = {};
$a3c7a446c9cb575f$exports = import.meta.resolve("ktRok");


var $a87c5def27dc4038$exports = {};
$a87c5def27dc4038$exports = import.meta.resolve("bYg5s");


var $8b7be7a248295adc$exports = {};
$8b7be7a248295adc$exports = import.meta.resolve("khzPo");


var $13c9af333866900d$exports = {};
$13c9af333866900d$exports = import.meta.resolve("e0UML");


var $515a8c6accd56df3$exports = {};
$515a8c6accd56df3$exports = import.meta.resolve("kTTgR");


var $84e43c8aa2a5a570$exports = {};
$84e43c8aa2a5a570$exports = import.meta.resolve("d4Kbe");


var $825ea4b043b4bada$exports = {};
$825ea4b043b4bada$exports = import.meta.resolve("l8hZY");


var $b982bed6cc22f326$exports = {};
$b982bed6cc22f326$exports = import.meta.resolve("hyrRD");


var $2c92eed12886aa45$exports = {};
$2c92eed12886aa45$exports = import.meta.resolve("lInvN");


var $c9f81b212193d68b$exports = {};
$c9f81b212193d68b$exports = import.meta.resolve("dzJtM");


var $b27fd0584e8e9b54$exports = {};
$b27fd0584e8e9b54$exports = import.meta.resolve("bVADn");


var $893d9132ed8cc662$exports = {};
$893d9132ed8cc662$exports = import.meta.resolve("iDWWW");


var $12e046a91d2a3e83$exports = {};
$12e046a91d2a3e83$exports = import.meta.resolve("49Gza");


var $ae200ac43b187ee5$exports = {};
$ae200ac43b187ee5$exports = import.meta.resolve("lNYFa");


var $b0251596435d145d$exports = {};
$b0251596435d145d$exports = import.meta.resolve("aqcfo");


var $24ab2c424b7df4f6$exports = {};
$24ab2c424b7df4f6$exports = import.meta.resolve("3eeq0");


var $fae3151b38f9a047$exports = {};
$fae3151b38f9a047$exports = import.meta.resolve("7gCVI");


var $e1d56e734428c974$exports = {};
$e1d56e734428c974$exports = import.meta.resolve("7tubR");


var $fbaccabe299ce7a0$exports = {};
$fbaccabe299ce7a0$exports = import.meta.resolve("42dST");


var $c9ff9b2d8023443d$exports = {};
$c9ff9b2d8023443d$exports = import.meta.resolve("k0E5P");


var $945fa9fc104a1c46$exports = {};
$945fa9fc104a1c46$exports = import.meta.resolve("kjx5B");


var $563550f6d475732b$exports = {};
$563550f6d475732b$exports = import.meta.resolve("4r081");


var $99a6e19aeefc28dd$exports = {};
$99a6e19aeefc28dd$exports = import.meta.resolve("k15WL");


var $23a4ac1286c25197$exports = {};
$23a4ac1286c25197$exports = import.meta.resolve("2bwlC");


var $1c8289871ed8ff54$exports = {};
$1c8289871ed8ff54$exports = import.meta.resolve("7axn1");


var $21dbf6ac0315ff62$exports = {};
$21dbf6ac0315ff62$exports = import.meta.resolve("6SkBI");


var $e50c013e543a115f$exports = {};
$e50c013e543a115f$exports = import.meta.resolve("fQMRB");


var $4a8cbec2377ac056$exports = {};
$4a8cbec2377ac056$exports = import.meta.resolve("jnb68");


var $e8f9bed7700cee72$exports = {};
$e8f9bed7700cee72$exports = import.meta.resolve("8dZ0U");


var $2e7d5529f258b79d$exports = {};
$2e7d5529f258b79d$exports = import.meta.resolve("yAba6");


var $e19bfa20e2dce6e3$exports = {};
$e19bfa20e2dce6e3$exports = import.meta.resolve("arrIL");


var $38a3364a10d4dcc3$exports = {};
$38a3364a10d4dcc3$exports = import.meta.resolve("76iQu");


var $0191fc40d460024d$exports = {};
$0191fc40d460024d$exports = import.meta.resolve("jEUdY");


var $fede860710e33ea5$exports = {};
$fede860710e33ea5$exports = import.meta.resolve("k5jEG");


var $b0d59eb957a126f4$exports = {};
$b0d59eb957a126f4$exports = import.meta.resolve("haiTb");


var $404101b31e760bde$exports = {};
$404101b31e760bde$exports = import.meta.resolve("dcqum");


var $825f4a0cee3617f4$exports = {};
$825f4a0cee3617f4$exports = import.meta.resolve("9iazO");


var $c728a857ea06eb3a$exports = {};
$c728a857ea06eb3a$exports = import.meta.resolve("9hyes");


var $6ff2cd3eaf6c015f$exports = {};
$6ff2cd3eaf6c015f$exports = import.meta.resolve("1Uvxj");


var $9981fae99fa01a54$exports = {};
$9981fae99fa01a54$exports = import.meta.resolve("fQSQL");


var $cc8d6e801fd2482c$exports = {};
$cc8d6e801fd2482c$exports = import.meta.resolve("7vnzS");


var $cf05a04024e9fc02$exports = {};
$cf05a04024e9fc02$exports = import.meta.resolve("7TtP9");


var $b3d7c19afb4e5a8a$exports = {};
$b3d7c19afb4e5a8a$exports = import.meta.resolve("45FIx");


var $3b5617f7ee7cd83b$exports = {};
$3b5617f7ee7cd83b$exports = import.meta.resolve("gJ7W7");


var $9b9901edea350c75$exports = {};
$9b9901edea350c75$exports = import.meta.resolve("dMvkX");


var $62184536ccb3dcdc$exports = {};
$62184536ccb3dcdc$exports = import.meta.resolve("fEq8w");


var $66f397c4f4b9b0cf$exports = {};
$66f397c4f4b9b0cf$exports = import.meta.resolve("9oiWI");


var $fe7e0c73f09f4df3$exports = {};
$fe7e0c73f09f4df3$exports = import.meta.resolve("kYlEe");


var $81bb52bb408a1be8$exports = {};
$81bb52bb408a1be8$exports = import.meta.resolve("2roZi");


var $dbc56fbbf0811646$exports = {};
$dbc56fbbf0811646$exports = import.meta.resolve("a6igv");


var $3bee5d05fb5ee89e$exports = {};
$3bee5d05fb5ee89e$exports = import.meta.resolve("iE99C");


const $f4d745ca65c6f196$export$5facad85907b0a4e = [
    (0, (/*@__PURE__*/$parcel$interopDefault($d824ac02dcbe793c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9fcc4e1a87df6bb1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($105107585656d7a1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cd6b3d843dd36c7a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f98255bb20d6f01d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b817889c311d658c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2f2837cb7c29ed33$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8ea81eb3acc6e8ae$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9eb516caffc94144$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e04717558299131f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($824ee16e93d6d83c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($55c81d50a45037f7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($deea6468d731ed7e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a0054ada609884ab$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($98954c3574c32d7a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0a928d506f97f81f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($220823fd231c632e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9a3e84b870b2c5a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6ff243045f5e7fff$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($55526fcb014aa526$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($86bda99d23b7338e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($60827b91d77b2f98$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2b618d3566cde27e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ed4fc4c9122b467c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2410511d0f6ef72c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b972700e0bee8397$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($876ed3e87ba4fa41$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b4adf4affb7af5fb$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($25bdebded56abd07$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a3c7a446c9cb575f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a87c5def27dc4038$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8b7be7a248295adc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($13c9af333866900d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($515a8c6accd56df3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($84e43c8aa2a5a570$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($825ea4b043b4bada$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b982bed6cc22f326$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2c92eed12886aa45$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9f81b212193d68b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b27fd0584e8e9b54$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($893d9132ed8cc662$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($12e046a91d2a3e83$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ae200ac43b187ee5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b0251596435d145d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($24ab2c424b7df4f6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fae3151b38f9a047$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e1d56e734428c974$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fbaccabe299ce7a0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9ff9b2d8023443d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($945fa9fc104a1c46$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($563550f6d475732b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($99a6e19aeefc28dd$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($23a4ac1286c25197$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1c8289871ed8ff54$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($21dbf6ac0315ff62$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e50c013e543a115f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4a8cbec2377ac056$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e8f9bed7700cee72$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2e7d5529f258b79d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e19bfa20e2dce6e3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($38a3364a10d4dcc3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0191fc40d460024d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fede860710e33ea5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b0d59eb957a126f4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($404101b31e760bde$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($825f4a0cee3617f4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c728a857ea06eb3a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6ff2cd3eaf6c015f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9981fae99fa01a54$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cc8d6e801fd2482c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cf05a04024e9fc02$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b3d7c19afb4e5a8a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3b5617f7ee7cd83b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9b9901edea350c75$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($62184536ccb3dcdc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($66f397c4f4b9b0cf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fe7e0c73f09f4df3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($81bb52bb408a1be8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dbc56fbbf0811646$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3bee5d05fb5ee89e$exports)))
];


/*
 * Scrollgesteuerte LKW-Bildsequenz.
 *
 * Der Fortschritt wird ausschließlich aus der Lage der per `position: sticky`
 * fixierten Bühne innerhalb ihrer Bahn abgeleitet. Das Skript scrollt nicht
 * selbst und unterdrückt keine Scroll-Geste: Firefox/Android scrollt auf dem
 * Compositor-Thread, jede Korrektur per `scrollTo` käme einen Frame zu spät
 * und wäre als Sprung sichtbar.
 *
 * Gezeichnet wird in ein <canvas>. Ein Wechsel von `img.src` würde in Firefox
 * kurzzeitig die intrinsische Bildgröße verlieren und damit bei jedem Frame
 * das Layout umbrechen.
 */ // Auf Mobilgeräten wird nur jeder n-te Frame verwendet — halbe Datenmenge und
// halbe Decode-Last. Auf 1 setzen, um die volle Sequenz zu erzwingen.
const $3e70b6fd7cbc7693$var$MOBILE_FRAME_STRIDE = 2;
// Gleichzeitig laufende Bild-Requests. Alle Frames auf einmal anzustoßen
// blockiert auf dem Handy Netz und Decoder genau dann, wenn die Sequenz
// beginnen soll.
const $3e70b6fd7cbc7693$var$PRELOAD_CONCURRENCY = 6;
// Abstand zum Viewport, ab dem vorgeladen wird.
const $3e70b6fd7cbc7693$var$PRELOAD_ROOT_MARGIN = '150% 0px';
// Backing-Store nie über diesen Faktor hinaus vergrößern.
const $3e70b6fd7cbc7693$var$MAX_PIXEL_RATIO = 2;
const $3e70b6fd7cbc7693$var$MOBILE_QUERY = '(max-width: 768px)';
const $3e70b6fd7cbc7693$var$REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
function $3e70b6fd7cbc7693$var$frameUrl(index) {
    const asset = (0, $f4d745ca65c6f196$export$5facad85907b0a4e)[index];
    return typeof asset === 'string' ? asset : asset.default;
}
function $3e70b6fd7cbc7693$export$4c22c8dc3c4cd0e1() {
    const track = document.querySelector('[data-truck-sequence]');
    const stage = track?.querySelector('[data-truck-stage]');
    const canvas = track?.querySelector('[data-truck-canvas]');
    if (!track || !stage || !canvas) return;
    const context = canvas.getContext('2d', {
        alpha: false
    });
    if (!context) return;
    const mobileQuery = window.matchMedia($3e70b6fd7cbc7693$var$MOBILE_QUERY);
    const reducedMotionQuery = window.matchMedia($3e70b6fd7cbc7693$var$REDUCED_MOTION_QUERY);
    let frames = [];
    let sourceWidth = 0;
    let renderedIndex = -1;
    let renderScheduled = false;
    let preloading = false;
    // Kennzeichnet den aktuellen Ladedurchlauf. Nach einem Neuaufbau dürfen
    // noch laufende Ladeketten des alten Durchlaufs nicht weiterarbeiten.
    let preloadToken = 0;
    let inView = false;
    const isActive = ()=>!reducedMotionQuery.matches;
    const buildFrames = ()=>{
        const stride = mobileQuery.matches ? $3e70b6fd7cbc7693$var$MOBILE_FRAME_STRIDE : 1;
        const urls = [];
        for(let index = 0; index < (0, $f4d745ca65c6f196$export$5facad85907b0a4e).length; index += stride)urls.push($3e70b6fd7cbc7693$var$frameUrl(index));
        // Der Schlussframe muss erhalten bleiben, sonst endet die Sequenz je
        // nach Schrittweite vor der letzten Position.
        const lastUrl = $3e70b6fd7cbc7693$var$frameUrl((0, $f4d745ca65c6f196$export$5facad85907b0a4e).length - 1);
        if (urls[urls.length - 1] !== lastUrl) urls.push(lastUrl);
        return urls.map((url)=>({
                url: url,
                image: null,
                ready: false
            }));
    };
    // Backing-Store an die tatsächliche Anzeigegröße anpassen. Gibt zurück, ob
    // sich etwas geändert hat — ein Resize leert die Canvas, danach muss neu
    // gezeichnet werden.
    const resizeCanvas = ()=>{
        const rect = canvas.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return false;
        const ratio = Math.min(window.devicePixelRatio || 1, $3e70b6fd7cbc7693$var$MAX_PIXEL_RATIO);
        const limit = sourceWidth || Number.POSITIVE_INFINITY;
        const width = Math.max(1, Math.min(Math.round(rect.width * ratio), limit));
        const height = Math.max(1, Math.round(width * (rect.height / rect.width)));
        if (canvas.width === width && canvas.height === height) return false;
        canvas.width = width;
        canvas.height = height;
        return true;
    };
    // Solange ein Frame noch lädt, den nächstgelegenen bereits dekodierten
    // zeichnen. Das ist deutlich ruhiger als eine Lücke in der Sequenz.
    const drawableFrame = (index)=>{
        for(let offset = 0; offset < frames.length; offset += 1){
            const earlier = frames[index - offset];
            if (earlier && earlier.ready) return earlier;
            const later = frames[index + offset];
            if (later && later.ready) return later;
        }
        return null;
    };
    const draw = (index)=>{
        const exact = frames[index];
        const frame = exact && exact.ready ? exact : drawableFrame(index);
        if (!frame || !frame.image) return;
        context.drawImage(frame.image, 0, 0, canvas.width, canvas.height);
        track.classList.add('is-playing');
    };
    // Fortschritt = Weg, den die Bühne innerhalb ihrer Bahn bereits
    // zurückgelegt hat. Beide Rects stammen aus demselben Frame, das Ergebnis
    // ist damit unabhängig von `window.scrollY` und von der Frage, wann der
    // Browser das Scroll-Event zustellt.
    const currentIndex = ()=>{
        const trackRect = track.getBoundingClientRect();
        const stageRect = stage.getBoundingClientRect();
        const travel = trackRect.height - stageRect.height;
        if (travel <= 0) return 0;
        const progress = Math.min(Math.max((stageRect.top - trackRect.top) / travel, 0), 1);
        return Math.round(progress * (frames.length - 1));
    };
    const render = ()=>{
        if (!isActive() || frames.length === 0) return;
        const index = currentIndex();
        const resized = resizeCanvas();
        if (index === renderedIndex && !resized) return;
        renderedIndex = index;
        draw(index);
    };
    const requestRender = ()=>{
        if (renderScheduled) return;
        renderScheduled = true;
        window.requestAnimationFrame(()=>{
            renderScheduled = false;
            render();
        });
    };
    const forceRender = ()=>{
        renderedIndex = -1;
        requestRender();
    };
    const startPreload = ()=>{
        if (preloading || !isActive() || frames.length === 0) return;
        preloading = true;
        const token = preloadToken;
        let nextIndex = 0;
        const loadNext = ()=>{
            if (token !== preloadToken) return;
            const index = nextIndex;
            nextIndex += 1;
            const frame = frames[index];
            if (!frame) return;
            const image = new Image();
            image.decoding = 'async';
            frame.image = image;
            const settle = ()=>{
                if (token !== preloadToken) return;
                frame.ready = true;
                if (sourceWidth === 0) sourceWidth = image.naturalWidth;
                forceRender();
                loadNext();
            };
            image.onload = ()=>{
                // Erst nach dem Dekodieren nachladen: so bleibt auch die
                // Decoder-Last begrenzt, nicht nur die Zahl der Requests.
                if (typeof image.decode === 'function') image.decode().then(settle, settle);
                else settle();
            };
            image.onerror = ()=>{
                frame.image = null;
                loadNext();
            };
            image.src = frame.url;
        };
        for(let slot = 0; slot < Math.min($3e70b6fd7cbc7693$var$PRELOAD_CONCURRENCY, frames.length); slot += 1)loadNext();
    };
    const applyMode = ()=>{
        track.dataset.truckMode = isActive() ? 'scroll' : 'static';
    };
    // Neuaufbau nach Breakpoint- oder Motion-Wechsel. Die Canvas behält dabei
    // bewusst ihren letzten Inhalt, bis der erste neue Frame dekodiert ist.
    const reset = ()=>{
        frames = buildFrames();
        preloadToken += 1;
        preloading = false;
        renderedIndex = -1;
        if (inView) startPreload();
        requestRender();
    };
    applyMode();
    reset();
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                inView = entry.isIntersecting;
                if (inView) startPreload();
            }
        }, {
            rootMargin: $3e70b6fd7cbc7693$var$PRELOAD_ROOT_MARGIN
        });
        observer.observe(track);
    } else {
        inView = true;
        startPreload();
    }
    window.addEventListener('scroll', requestRender, {
        passive: true
    });
    window.addEventListener('resize', forceRender, {
        passive: true
    });
    window.addEventListener('orientationchange', forceRender, {
        passive: true
    });
    if ('ResizeObserver' in window) new ResizeObserver(forceRender).observe(stage);
    const onMediaChange = ()=>{
        applyMode();
        reset();
    };
    mobileQuery.addEventListener('change', onMediaChange);
    reducedMotionQuery.addEventListener('change', onMediaChange);
}


function $e366f2c43bf887ab$var$removePreloader() {
    const pre = document.getElementById('preloader');
    if (pre && pre.parentNode) pre.parentNode.removeChild(pre);
}
function $e366f2c43bf887ab$var$initHeroAnimation() {
    const teaser = document.getElementById('teaser');
    if (teaser) teaser.classList.add('animate-in');
}
function $e366f2c43bf887ab$var$onDOMContentLoaded() {
    document.documentElement.classList.add('dom-ready');
    document.body.classList.add('dom-ready');
    // LazyLoad zuerst
    (0, $32a3a3f71f269bc5$export$3b98fa096e9fc203)(document);
    // Video-Pfade aus HTML auslesen und speichern
    (0, $32a3a3f71f269bc5$export$c3bf910d26c7ca3b)();
    (0, $e745b9ef5c505b0a$export$b61d4be8ddba9539)();
}
function $e366f2c43bf887ab$var$onWindowLoad() {
    document.documentElement.classList.add('loaded');
    document.body.classList.add('loaded');
    $e366f2c43bf887ab$var$removePreloader();
    // Hero-Animation sofort triggern
    $e366f2c43bf887ab$var$initHeroAnimation();
    // Animationen erst NACH Preloader-Entfernung
    (0, $b611819413d23cbb$export$4ae6feb6159b4594)();
    // Scroll-Morph initialisieren
    (0, $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c)();
    // Scroll-Heading initialisieren
    (0, $0e5e9a9af84e2131$export$c80c5dc5e82459e5)();
    (0, $3e70b6fd7cbc7693$export$4c22c8dc3c4cd0e1)();
    // Video Setup mit richtiger Variante
    (0, $32a3a3f71f269bc5$export$730a095e8e4092e5)();
}
function $e366f2c43bf887ab$export$c1e92a604cbf4acd() {
    if (document.readyState === 'complete') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        $e366f2c43bf887ab$var$onWindowLoad();
        return;
    }
    if (document.readyState === 'interactive') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
            once: true
        });
        return;
    }
    window.addEventListener('DOMContentLoaded', $e366f2c43bf887ab$var$onDOMContentLoaded, {
        once: true
    });
    window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
        once: true
    });
}
// Auto-init when module is imported
$e366f2c43bf887ab$export$c1e92a604cbf4acd();


//# sourceMappingURL=pktrans_26.a3da40fb.js.map
